import { isConvertibleExtension } from '@picsio/db/src/fileTypes';
import isCropSupportedFormat from './isCropSupportedFormat';

/**
 * Single source of truth for "can this asset be converted into a rendition"
 * (resize/crop/format change). Reused by bulk-copy flags and the unsupported
 * format summary so copy/download flows agree on what counts as supported.
 */
export function isAssetConvertibleForBulkCopy(asset) {
  if (!asset) return false;
  if (asset.isConvertibleFormat === false) return false;
  if (asset.isConvertibleFormat === true) return true;
  const ext = (asset.fileExtension || '').toLowerCase();
  return isConvertibleExtension(ext);
}

/**
 * Aggregated selection flags for bulk copy / conversion UI (and server-side parity).
 * `bulkCopyAllConvertible` — every selected asset supports format conversion.
 * `bulkCopyAllCroppable` — every selected asset supports copy-crop (see
 * `@picsio/db` `NON_CROPPABLE_EXTENSIONS` / `NON_CROPPABLE_MIMES`).
 * `unsupportedFormatsCount` — exact number of selected assets that cannot be
 * converted into a rendition (kept in parity with the server response).
 */
export default function computeBulkCopySelectionFlags(assets) {
  if (!Array.isArray(assets) || assets.length === 0) {
    return { bulkCopyAllConvertible: true, bulkCopyAllCroppable: true, unsupportedFormatsCount: 0 };
  }
  const unsupportedFormatsCount = assets.filter((a) => !isAssetConvertibleForBulkCopy(a)).length;
  return {
    bulkCopyAllConvertible: unsupportedFormatsCount === 0,
    bulkCopyAllCroppable: assets.every(
      (a) => a && isCropSupportedFormat(a.mimeType, a.fileExtension),
    ),
    unsupportedFormatsCount,
  };
}
